import { BupError } from '@BUP/lib/errors'

export const enrichError = (error) => {
  const baseInfo = {
    name: error?.name,
    message: error?.message,
    stack: error?.stack
  }

  if (error?.isAxiosError) {
    return {
      ...baseInfo,
      isAxiosError: true,
      url: error?.config?.url,
      method: error?.config?.method,
      requestData: error?.config?.data,
      status: error?.response?.status,
      responseData: error?.response?.data
    }
  }

  if (error instanceof BupError) {
    return {
      ...baseInfo,
      isBupError: true,
      code: error.code,
      metadata: error.metadata
    }
  }

  return baseInfo
}
